import {Logger, LogLevel} from "platform/logger/Logger";
import {ConfigurationLoader, PlatformConfiguration} from "platform/configuration/ConfigurationLoader";
import Utils from "platform/util/Utils";
import {LangCode} from "platform/enum/LangCode";
import {Http} from "platform/network/http/Http";

export interface Configuration extends PlatformConfiguration {

    brandId?: number;
    chartUrl?: string;
    chartEquityUrl?: string;
    amazonPathIconSymbol?: string;
    amazonPathIconChart?: string;
    webPushSDK?: string;
    webPushTargetId?: string;
    supportedLanguages?: LangCode[];
    inActiveTraderIdleTimeBeforeLogoff?: number;
    activeTraderIdleTimeBeforeLogoff?: number;
    locale?: LocaleConfig;
}

export class LocaleConfig {

    formats?: {
        dates?: {
            dateFormats?: {
                yMMMMEEEEd: string;
                yMMMMd: string;
                yMMMd: string;
                yMd: string;
            },
            timeFormats?: {
                hm: string;
                hms: string;
                hmsz: string;
            }
        },
        numbers?: {
            decimalDelimiter: string;
            thousandDelimiter: string;
        }
    }
}

export default class ConfigManager {

    private static _logger: Logger = Logger.Of("ConfigManager");
    private static _loader: ConfigurationLoader<Configuration>;
    private static _config: Configuration = {
        logLevel: LogLevel.DEBUG as any,
        brand: "-",
        supportedLanguages: [LangCode.EN],
        activeTraderIdleTimeBeforeLogoff: 3600000,
        inActiveTraderIdleTimeBeforeLogoff: 1200000
    };

    private constructor() {
    }

    public static config(): Configuration {
        return this._config;
    }

    public static loader(): ConfigurationLoader<Configuration> {
        if (Utils.isNull(this._loader)) {
            this._loader = {
                load(): Promise<Configuration> {
                    return new Promise<Configuration>(
                        (resolve, reject) => {
                            Http.getJson("resources/configuration/config.json").then((config: Configuration) => {
                                ConfigManager._logger.info("Configuration loaded");
                                try {
                                    const result: Configuration = Object.assign({}, ConfigManager._config, config);
                                    ConfigManager._config = result;
                                    resolve(result);
                                } catch (e) {
                                    ConfigManager._logger.warn("Failed to merge configuration. " + JSON.stringify(e) + " Going to use hardcoded configuration");
                                    resolve(ConfigManager._config);
                                }
                            }).catch((e) => {
                                ConfigManager._logger.warn("Failed to load configuration: " + JSON.stringify(e));
                                reject();
                            });
                        }
                    );
                }
            };
        }
        return this._loader;
    }
}
